module.exports = __webpack_public_path__ + "static/media/dot-grey.1cd376dd.svg";